<template>
    <div v-if="loading" class="progress-loading">
       <img src="/img/loading.gif" class="progress-loading__img" alt="" />
    </div>
</template>

<script>
export default {
    name: "ProgressLoading",
    props: {
        loading: {
                type: Boolean
        }
    },
    methods: {
        setLoading() {
            this.$emit("setLoading", false);
        },
    },
}
</script>

<style scoped>
.progress-loading {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.progress-loading__img {
  display: block;
  max-height: 35px;
}
</style>